import { Entity } from 'engine/Entity';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { RoadSprite } from './RoadSprite';

export class RoadEntity extends Entity {
  zIndex = -1;
  createFacets() {
    return [create(StaticSpriteFacet, { frame: RoadSprite })];
  }
}
